module.exports={
  noResult:            'Linea aerea non trovata'
}
